import { Component, OnInit, DoCheck } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

// const URL = ''../api/impotest/importar';;

const URLIMPO = `${environment.backendUrlImpo}/api/importadorall/importar`;
const URLDESP = `${environment.backendUrlImpo}/api/importadorall/desprocesar`;



@Component({
  selector: 'app-importadorall',
  templateUrl: './importadorall.component.html',
  styleUrls: ['./importadorall.component.css']
})
export class ImportadorallComponent implements OnInit, DoCheck {
  response: string;
  array = [];
  ultimoProcesado;
  lUltimo = false;

  public uploader: FileUploader = new FileUploader({
    url: URLIMPO,
    itemAlias: 'afip',
    headers: [
      // { name: 'Access-Control-Allow-Origin', value: '*' }
    ]
  });

  constructor(private http: HttpClient) {
    this.response = '';
    this.uploader.response.subscribe( res => this.response = res );
    this.getUltimoProcesado();
  }

  ngDoCheck() {

    // console.log(this.uploader);
    // console.log('uploader/options/url', this.uploader.options.url);
    // if (this.uploader.queue.length > 0) {
    //   console.log('uploader/queue[0].url', this.uploader.queue[0].url);
    // }


  }

  ngOnInit(): void {
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      // console.log('Archivo de afip importado con éxito', item, status, response);
      // console.log('ESTADO:' , status);
      const status2 = status;
      // console.log('progreso:', item.progress);

      this.array[item.file.name] = response;
      // console.log('item', item.file ? item.file.name : '-');
    };

    // tslint:disable-next-line: no-unused-expression
    this.uploader;
  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterViewInit() {
    console.log('uploader ready');
    this.uploader.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };
    this.uploader.onAfterAddingFile = (item) => {
      item.withCredentials = false;
      item.remove();
      if (
        this.uploader.queue.filter((f) => f._file.name === item._file.name)
          .length === 0
      ) {
        this.uploader.queue.push(item);
      } else {
        alert('Archivo duplicado!');
      }
    };

  }


  uploadItem(item) {
    const fileName = item.file.name;
    // this.uploader.options.url = '../api/importadorall/importar';
    this.uploader.options.url = URLIMPO;
    // console.log('itemTocado: ', item.file.name);

    for (let i = 0; i < this.uploader.queue.length; i++) {
      if (this.uploader.queue[i].file.name === fileName) {
        this.uploader.queue[i].url = URLIMPO;
        // console.log( 'IMPORTANDO ARCHIVO ' + fileName );
      }
    }
    // console.log('UPLOADER= ', this.uploader);
    console.log('BACKEND+URL=', URLIMPO);

    this.uploader.uploadItem( item );
  }

  uploadAll() {

    this.uploader.options.url = URLIMPO;
    for (let i = 0; i < this.uploader.queue.length; i++) {

      this.uploader.queue[i].url = URLIMPO;
      this.uploader.queue[i].isSuccess = false;
      this.uploader.queue[i].isUploaded = false;
      this.uploader.queue[i].isReady = false;

    }
    this.uploader.uploadAll();

  }

  desprocesarItem( item ) {

    const fileName = item.file.name;
    this.uploader.options.url = URLDESP;
    // this.uploader.queue[0].url = '../api/importadorall/desprocesar';
    console.log('itemTocado: ', item.file.name);

    for (let i = 0; i < this.uploader.queue.length; i++) {
      if (this.uploader.queue[i].file.name === fileName) {
        this.uploader.queue[i].url = URLDESP;
        console.log( 'DESPROC. ARCHIVO ' + fileName );
      }
    }

    this.uploader.uploadItem( item );

  }

  desprocesarTodo() {
    this.uploader.cancelAll();
    this.uploader.options.url = URLDESP;
    for (let i = 0; i < this.uploader.queue.length; i++) {

      this.uploader.queue[i].url = URLDESP;
      this.uploader.queue[i].isReady = true;

    }

    this.uploader.uploadAll();
    // alert('Desprocesando el mes completo..');
  }

  clearAll() {
    this.array = [];
  }

  clearItem(item) {
    // console.log('borrar', item );
    // this.array.splice(item, 1);
    this.array[item] = [];
    console.log('curado', this.array );
  }

  getUltimoProcesado() {
    this.lUltimo = true;
    // http://localhost:1337/api/sinomyt/getAFIP?afip=nominas
      this.http.get(`${environment.backendUrl}/api/sinomyt/getAFIP?afip=nominas`)
      .subscribe((res: any[]) => {
        if (res) {
          this.ultimoProcesado = res[0];
          // console.log('utlimo: ', res[0]);
          this.lUltimo = false;
        } else {
          console.warn('fallo la busqueda del ultimo txt');
          this.lUltimo = false;
        }
      });
  }

}
